import { orderVolumes } from './helpers'


const totalVolume = (volume) => {
    if (volume !== undefined && volume !== null) {
        return volume
    }

    return 'N/A'
}

export const xDeviceVolumes = (volumes, providerFirstIdActivated, firstPartyCookie, providerUtiqActivated) => {
    if (!volumes) return []

    const xDeviceVolumeData = {
        total_users_desktop: {
            icon: 'desktop-volume',
            label: 'Web',
        },
        total_users_desktop_first: {
            icon: 'desktop-first',
            label: 'Web 1st',
        },
        total_users_crm: {
            icon: 'crm-id',
            label: 'CRM IDs',
        },
        total_users_mobile: {
            icon: 'app-volume',
            label: 'App',
        },
        total_users_firstid: {
            icon: 'first-id-volume',
            label: 'First-id',
        },
        total_users_utiq_mobile: {
            icon: 'utiq',
            label: 'Utiq Mobile',
        },
        total_users_utiq_home: {
            icon: 'utiq',
            label: 'Utiq Home',
        },
    }

    const $volumes = []
    const order = orderVolumes('xdevice')
    if (volumes?.total_xdevice) {
        order.forEach((key) => {
            if (volumes.total_xdevice.hasOwnProperty(key) || ['total_users_utiq_home', 'total_users_utiq_mobile'].includes(key)) {
                if (key === 'total_users_firstid' && !providerFirstIdActivated) return
                if (key === 'total_users_desktop_first' && !firstPartyCookie) return
                if (key === 'total_users_utiq_home' && !providerUtiqActivated) return
                if (key === 'total_users_utiq_mobile' && !providerUtiqActivated) return
                if (!xDeviceVolumeData[key]) return

                const tmp = volumes.total_xdevice[key] === undefined ? 0 : volumes.total_xdevice[key]

                $volumes.push({
                    key,
                    value: totalVolume(tmp),
                    label: xDeviceVolumeData[key].label,
                    icon: xDeviceVolumeData[key].icon
                })
            }
        })
    }

    return $volumes
}

export const idBasedVolumes = (volumes, providerFirstIdActivated, firstPartyCookie, providerUtiqActivated) => {
    if (!volumes) return []

    const idbasedVolumeData = {
        total_desktop: {
            icon: 'cookie',
            label: 'Cookie',
        },
        total_mobile: {
            icon: 'mobile-volume',
            label: 'Mobile',
        },
        total_desktop_first: {
            icon: 'cookie-1st',
            label: 'Cookie 1st',
        },
        total_crm: {
            icon: 'crm-id',
            label: 'CRM IDs',
        },
        total_firstid: {
            icon: 'first-id-volume',
            label: 'First-id',
        },
        total_utiq_mobile: {
            icon: 'utiq',
            label: 'Utiq Mobile',
        },
        total_utiq_home: {
            icon: 'utiq',
            label: 'Utiq Home',
        },
    }

    const $volumes = []
    const order = orderVolumes('idbased')

    order.forEach((key) => {
        if (volumes?.hasOwnProperty(key) || ['total_utiq_home', 'total_utiq_mobile'].includes(key)) {
            if (key === 'total_firstid' && !providerFirstIdActivated) return
            if (key === 'total_desktop_first' && !firstPartyCookie) return
            if (key === 'total_utiq_home' && !providerUtiqActivated) return
            if (key === 'total_utiq_mobile' && !providerUtiqActivated) return
            if (!idbasedVolumeData[key]) return

            const tmp = volumes[key] === undefined ? 0 : volumes[key]
            $volumes.push({
                key,
                value: totalVolume(tmp),
                label: idbasedVolumeData[key].label,
                icon: idbasedVolumeData[key].icon,
            })
        }
    })
    return $volumes
}
